import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { geeImageSelected } from '../../domain/types';
import { Alert } from '../../domain/interfaces/Alert.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertMetadataService {

  //selectedBuffer: WritableSignal<BufferType> = signal<BufferType>(null);
  selectedAlert: WritableSignal<Alert> = signal<Alert>(null);
  geeImageSelected = signal<geeImageSelected>(null);
  processingImages = signal<boolean>(false);
  isImageUndefined = signal<boolean>(true);

  // setSelectedBuffer(buffer: BufferType) {
  //   this.selectedBuffer.set(buffer);
  // }

  setSelectedAlert(alert: Alert) {
    alert ? this.selectedAlert.set(alert): this.selectedAlert.set(null);
  }
}
